import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavParams, ViewController } from "ionic-angular";
import { ESignedAction } from "models/order-management/eSignedAction";
import { Action } from "models/order-management/models";
import { OrderPatchRequest } from "models/order-management/orderPatchRequest";
import * as moment from "moment-timezone";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { UtilityService } from "providers/utility-service/utility-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

@Component({
  selector: "e-sign-order",
  templateUrl: "e-sign-order.html",
})
export default class ESignOrder {
  orderId: string;
  eSignForm: FormGroup;
  userDisplayName: string;
  signatureRequest: Action.SignatureRequestEnum;

  constructor(
    public stateDate: StateManagementService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private orderManagementDataService: OrderManagementDataService,
    private utilService: UtilityService,
    private fb: FormBuilder
  ) {
    this.userDisplayName = this.navParams.data.userDisplayName;
    this.orderId = this.navParams.data.orderId;
    this.signatureRequest = this.navParams.data.signatureRequest;
    this.eSignForm = new FormGroup({
      providerName: this.fb.control(this.userDisplayName, Validators.required),
      eSignatureDate: this.fb.control(
        new Date().toDateString(),
        Validators.required
      ),
      note: this.fb.control(""),
    });
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true, shouldReload: false });
  }

  save() {
    let eSignAction: ESignedAction = {
      actionType: Action.ActionTypeEnum.ESigned,
      displayName: this.eSignForm.get("providerName").value,
      timezone: moment.tz.guess(),
      eSignatureDate: new Date(
        this.eSignForm.get("eSignatureDate").value
      ).toISOString(),
      attestation: true,
      notes: this.eSignForm.get("note").value,
      signatureRequests: [this.signatureRequest],
    };
    let eSignPath: OrderPatchRequest = {
      ...eSignAction,
    };
    this.utilService.increaseSpinnerCount("Saving...");
    this.orderManagementDataService
      .updateOrder(this.orderId, eSignPath)
      .finally(() => this.utilService.decreaseSpinnerCount())
      .subscribe(
        () => this.viewCtrl.dismiss({ shouldReload: true }),
        () => {
          this.utilService.presentCustomErrorToast("Error e-Signing order");
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/e-sign/e-sign-order.ts